// 强制等待元素加载 + 轮询检测，确保能找到元素
function updateProductLinks() {
    // 替换成你的实际链接！！！这一步必须做
    const productLinks = {
        'Laservii M1s 12W': '/products/m1s-enclosed-laser-engraver?variant=45488528097436', // 改成12W的真实链接
        'Laservii M1s 24W': '/products/m1s-enclosed-laser-engraver?variant=45603901603996', // 改成24W的真实链接
        'Laservii M1s IR-2W': '/products/m1s-enclosed-laser-engraver?variant=45603901636764' // 改成IR-2W的真实链接
    };

    // 定位所有产品链接
    const productItems = document.querySelectorAll('.gm-item .gm-image a');
    let replacedCount = 0;

    productItems.forEach(link => {
        const productTitle = link.getAttribute('title');
        if (productLinks[productTitle]) {
            link.setAttribute('href', productLinks[productTitle]);
            replacedCount++;
            console.log(`✅ 替换成功：${productTitle} → ${productLinks[productTitle]}`);
        }
    });

    // 控制台提示，方便排查
    if (replacedCount === 0) {
        console.log('❌ 未找到可替换的产品链接，检查：');
        console.log('1. 产品title是否匹配（比如多空格/符号）');
        console.log('2. 选择器.gm-item .gm-image a是否正确');
        // 打印当前页面所有gm-item下的title，帮你核对
        const allTitles = Array.from(productItems).map(link => link.getAttribute('title'));
        console.log('当前页面找到的产品title：', allTitles);
    } else {
        console.log(`✅ 共替换 ${replacedCount} 个产品链接`);
    }
}

// 方案1：DOM加载完成后执行
document.addEventListener('DOMContentLoaded', updateProductLinks);

// 方案2：页面完全加载（包括图片/动态内容）后再执行一次，双重保障
window.addEventListener('load', updateProductLinks);

// 方案3：如果是动态加载的元素，轮询检测5秒（防止元素延迟渲染）
let pollTimer = setInterval(() => {
    const productItems = document.querySelectorAll('.gm-item .gm-image a');
    if (productItems.length > 0) {
        updateProductLinks();
        clearInterval(pollTimer); // 找到元素后停止轮询
    }
}, 300); // 每300毫秒检测一次

// 5秒后强制停止轮询（避免无限循环）
setTimeout(() => {
    clearInterval(pollTimer);
}, 5000);